module.exports = __webpack_public_path__ + "img/ck3-mongol-siege.a9486d97.jpg";